import { AxiosRequest } from '.';
import AbstractModuleFactory from '@core/shared/module-factory';
import { CacheableURL, ICacheableURLBuilder, URLParams } from './types';

/**
 * ### Cacheable URL Builder
 *
 * Abstraction for caching a url.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export class CacheableURLBuilder implements ICacheableURLBuilder {
  // This values became unit for any time this builder is called.
  private endpoint: string;
  private stringURL: string;

  private joinParams(params?: URLParams): string {
    if (!params) return '';
    if (!Object.keys(params).length) return '';
    const stringParams = Object.entries(params);
    return stringParams.map(([key, value]) => `${key}=${value}`).join('&');
  }

  public buildURL(url: string, params?: URLParams): CacheableURL {
    this.endpoint = url;
    const stringParams = this.joinParams(params);
    if (stringParams === '') this.stringURL = url;
    else this.stringURL = `${url}${url.includes('?') ? '&' : '?'}${stringParams}`;
    return this;
  }

  public cacheMilliseconds(milliseconds: number): CacheableURL {
    AxiosRequest.setURLExpirationTime(this.stringURL, milliseconds);
    return this;
  }

  public restartCacheExpirationTime(): CacheableURL {
    AxiosRequest.restartURLExpirationTime(this.stringURL);
    return this;
  }

  public expireCacheForEnpoint(): CacheableURL {
    AxiosRequest.expireEnpoint(this.endpoint);
    return this;
  }

  public get(): string {
    return this.stringURL;
  }
}

/**
 * ### Cacheable URL Factory
 *
 * Module entry point
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export class CacheableURLFactory extends AbstractModuleFactory {
  createCacheableURL(): CacheableURLBuilder {
    return this.ensureInstance('CacheableURL', () => new CacheableURLBuilder());
  }

  static new(): CacheableURLFactory {
    return new CacheableURLFactory();
  }
}

const URLFactory = CacheableURLFactory.new();

export default URLFactory;
